<template>
    <b-form-modal title="Esqueceu sua senha?" @submit="sendEmail">
        <b-field label="Informe seu e-mail"
                 message="Por favor informe o seu e-mail para enviarmos o link para criar uma nova senha de acesso">
            <b-input type="email" placeholder="Informe seu e-mail" v-model="email" required/>
        </b-field>
        <button class="button is-primary" type="submit" slot="footer" :disabled="!email">Enviar e-mail</button>
    </b-form-modal>
</template>

<script>
import auth from "@/services/auth";

export default {
    name: "ForgotPasswordModal",

    data() {
        return {
            email: null
        }
    },

    methods: {
        async sendEmail() {
            const loading = this.$buefy.loading.open({canCancel: false});

            try {
                await auth.sendPasswordResetEmail(this.email)

                this.$buefy.toast.open({
                    message: 'E-mail enviado com sucesso, por favor acesse sua caixa de entrada e clique no link para criar uma nova senha',
                    type: 'is-success'
                });

            } catch (e) {
                this.$buefy.dialog.alert({
                    title: 'Ops algo deu errado',
                    message: 'Por favor informe o e-mail do seu usuário e tente novamente',
                    type: 'is-dark'
                });
            }
            
            loading.close();
        }
    }
}
</script>
